import React, { Component } from 'react';
import PropTypes from 'prop-types';
import momentPropTypes from 'react-moment-proptypes';
import { FormattedDate, FormattedMessage } from 'react-intl';

import moment from 'moment';
import EditableToggle from './EditableToggle';
import DatePicker from '../input/DatePicker';
import { isBeforeMinimum } from '../../utils/validationHelpers';
import FormattedDateShort from '../FormattedDateShort';
import dateMessages from '../../messages/dateMessages';

class EditableDatePicker extends Component {
  state = {
    isFocused: true,
  };

  handleModeChange = newMode => {
    if (newMode === 'edit') {
      this.setState({ isFocused: true });
    }
  };

  render() {
    const {
      onChange,
      value,
      submitOnSelect,
      inputClassName,
      displayClassName,
      readOnly,
      placeholder,
      isOutsideRange,
      nullDisplayValue,
      showTodayButton,
      anchorDirection,
      ...rest
    } = this.props;
    const { isFocused } = this.state;

    const dateValue = value ? moment.utc(value) : null;

    return (
      <EditableToggle
        onSubmit={onChange}
        onModeChange={this.handleModeChange}
        value={dateValue}
        readOnly={readOnly}
        displayValue={
          value ? <FormattedDateShort value={moment.utc(value).toDate()} /> : nullDisplayValue
        }
        className={displayClassName}
      >
        {({ inputValue, setInputValue, submit, cancel }) => (
          <DatePicker
            date={inputValue}
            onDateChange={date => {
              setInputValue(date).then(() => {
                if (date) submit(); // Submit when a date is valid
              });
            }}
            focused={isFocused}
            onFocusChange={({ focused }) => {
              this.setState(
                {
                  isFocused: focused,
                },
                () => {
                  if (!focused) {
                    // cancel when focus moved away from datepicker
                    cancel();
                  }
                },
              );
            }}
            showClearDate
            reopenPickerOnClearDate={false}
            isOutsideRange={isOutsideRange}
            small
            onClose={({ date }) => {
              if (inputValue === null && !date) {
                submit(); // Submit null value when closing datepicker with invalid date
              } else if (!date) cancel();
            }}
            placeholder={placeholder}
            {...(anchorDirection ? { anchorDirection } : {})}
            renderCalendarInfo={
              showTodayButton
                ? () => (
                    <div className="date-picker-today-info">
                      <button
                        type="button"
                        className="btn btn-today"
                        // Mousedown handler keeps DatePicker focused so onFocusChange's cancel() doesn't fire before submit.
                        onMouseDown={e => e.preventDefault()}
                        onClick={() => {
                          const today = moment.utc().startOf('day');
                          setInputValue(today).then(() => submit());
                        }}
                      >
                        <FormattedMessage {...dateMessages.Today} />
                      </button>
                      <button
                        type="button"
                        className="btn btn-default"
                        onMouseDown={e => e.preventDefault()}
                        onClick={cancel}
                      >
                        <FormattedMessage {...dateMessages.Cancel} />
                      </button>
                    </div>
                  )
                : undefined
            }
            {...rest}
          />
        )}
      </EditableToggle>
    );
  }
}

EditableDatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: momentPropTypes.momentObj,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.string,
  displayClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  nullDisplayValue: PropTypes.string,
  isOutsideRange: PropTypes.func,
  showTodayButton: PropTypes.bool,
  anchorDirection: PropTypes.oneOf(['left', 'right']),
  appendToBody: PropTypes.bool,
};
EditableDatePicker.defaultProps = {
  inputClassName: '',
  displayClassName: '',
  placeholder: '',
  nullDisplayValue: undefined,
  readOnly: false,
  value: null,
  isOutsideRange: isBeforeMinimum,
  showTodayButton: false,
  anchorDirection: undefined,
  appendToBody: false,
};

export default EditableDatePicker;
